<template src="@/templates/dhs/fileView.html"></template>

<script>
	import InvoiceByNumModel from '@/models/invoiceModel'

	export default {
		name: "fileView",
		props: ['jobID', 'hidePopUpOnClose'],
		data() {
			return {
				invoiceByNumModel: new InvoiceByNumModel(),
				fileViewPopUp: true,
				htmlTag: '',
				turn: 0,
				imageContent: ''
			}
		},
		computed: {
			style () {
				return {
					transform: 'rotate(' + this.turn + 'turn)'
				}
			}
		},
		created: function () {
			this.viewFile();
		},
		methods: {
			viewFile() {
				let url = this.invoiceByNumModel.setJobID(this.jobID) + '?invoiced=1&ignoreClientID=false';
				this.$http.get(url, {
					headers: {"Bearer": localStorage.getItem("jwt")}
				}).then((res) => {
					let resp = res.data;
					this.imageContent = resp.content;
					
					if (JSON.parse(resp.error) == false) {
						if (resp.file_extension == "jpeg" || resp.file_extension == "jpg" || resp.file_extension == "gif" || resp.file_extension == "png" || resp.file_extension == "tif")
							this.htmlTag = '<img src="data:image/jpeg;base64,' + this.imageContent + '" width="100%"/>';
						else if (resp.file_extension == "pdf")
							this.htmlTag = '<object width="100%" data="data:application/pdf;base64,' + this.imageContent + '" ' +
								'style="height:100vh"></object>';
						else
							this.htmlTag = '<span>File type is invalid for viewing.</span>';

					}
					else {
						this.htmlTag = resp.message;
					}
				}).catch(function (error) {
					console.log(error);
				});
			},
			closeFile() {
				Event.$emit('hideFileView', this.hidePopUpOnClose);
			},
			rotateImage() {
				this.turn += 0.25;
				this.htmlTag = '<img src="data:image/jpeg;base64,' + this.imageContent + '" width="100%" style="transform: rotate('+ this.turn +'turn)"/>';
			}
		}

	}
</script>

<style scoped>
	.invoiceModal >>> .modal-content {
		height: inherit !important;
		max-height: 800px !important;
	}
	
	.invoiceModal >>> .modal-content .modal-body .container-fluid object {
		height: 50vh !important;
		max-height: 800px !important;
	}
</style>




// WEBPACK FOOTER //
// src/components/dhs/fileView.vue